export default "__VITE_ASSET__CZfC0RE1__"